"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RangeAreaMaskChartPattern = exports.RANGE_AREA_MASK_ID = void 0;
var react_1 = __importDefault(require("react"));
exports.RANGE_AREA_MASK_ID = 'mask-range-area';
function RangeAreaMaskChartPattern() {
    return (react_1.default.createElement("defs", null,
        react_1.default.createElement("pattern", { id: exports.RANGE_AREA_MASK_ID, patternUnits: 'userSpaceOnUse', x: '0', y: '0', width: '10.5', height: '60', viewBox: '0 0 10.5 60' },
            react_1.default.createElement("rect", { width: '10.5', height: '60', fill: 'white', fillOpacity: '1' }),
            react_1.default.createElement("path", { d: '\n        M -10.5 60 L 0 0\n        M 0 60 L 10.5 0\n      ', stroke: '#D3D4DD', strokeWidth: '1.6', "shape-rendering": 'geometricPrecision' }))));
}
exports.RangeAreaMaskChartPattern = RangeAreaMaskChartPattern;
//# sourceMappingURL=RangeAreaMaskChartPattern.js.map